<template>
  <div>
    <div class="dashboard">
      Carriers
    </div>
  </div>
</template>

<script>
export default {
  name: "CarriersPage",
  data() {
    return {
      publicPath: process.env.VUE_APP_IMG_BASE_URL
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logOut");
      this.$router.push("/");
    }
  }
};
</script>
